import React from 'react';
import { Outlet } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute/PrivateRoute';
import Admin from '../../containers/Admin/Admin';
import { PageTitle } from '@project/components';

const PrivateRouteOutlet = () => {
  return (
    <PrivateRoute>
      <PageTitle title="Admin ID360" />
      <Admin>
        <Outlet />
      </Admin>
    </PrivateRoute>);
}

export default PrivateRouteOutlet;